// extracted by mini-css-extract-plugin
export default {"Buttons":"styles_Buttons__6YIkO"};